<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            ajax-path="freeradius/accounts"
        />        
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';
    import debounce from 'lodash/debounce';

    export default {
        data() {
            return {
                tableIsLoading: false,
                q: null,
                columns: [
                    {
                        title: 'Username',
                        field: 'username',
                        sorter: 'string',
                        minWidth: 300,
                    },
                    {
                        title: 'NAS Port ID',
                        field: 'nasportid',
                        sorter: 'string',
                        minWidth: 150,
                        visible: false,
                        download: true,
                    },
                    {
                        title: 'Start Time',
                        field: 'account_start_time_for_human',
                        sorter: 'string',
                        minWidth: 190,
                    },
                    {
                        title: 'Update Time',
                        field: 'account_update_time_for_human',
                        sorter: 'string',
                        minWidth: 190,
                    },
                    {
                        title: 'Stop Time',
                        field: 'account_stop_time_for_human',
                        sorter: 'string',
                        minWidth: 190,
                    },
                    {
                        title: 'Interval',
                        field: 'acctinterval',
                        sorter: 'number',
                        minWidth: 150,
                        visible: false,
                        download: true,
                    },
                    {
                        title: 'Session Time',
                        field: 'acctsessiontime',
                        sorter: 'number',
                        minWidth: 150,
                        formatter({_cell}) {
                            return _cell.row.data.session_time_for_human;
                        }
                    },
                    {
                        title: 'Upload (MB)',
                        field: 'upload_in_mb',
                        sorter: 'number',
                        minWidth: 150,
                    },
                    {
                        title: 'Download (MB)',
                        field: 'download_in_mb',
                        sorter: 'number',
                        minWidth: 160,
                    },
                    {
                        title: 'Terminate Cause',
                        field: 'acctterminatecause',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Framed IP Address',
                        field: 'framedipaddress',
                        sorter: 'string',
                        minWidth: 200,
                    }
                ],
            }
        },
    }
</script>